// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkOrButton_link__24hsu"};